var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneratedMessageCopyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83333 5H14.1667C15.175 5 16 5.9 16 7V15C16 16.1 15.175 17 14.1667 17H6.83333C5.825 17 5 16.1 5 15V7C5 5.9 5.825 5 6.83333 5Z",
    stroke: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.92V3C13 1.9 12.1 1 11 1H3C1.9 1 1 1.9 1 3V11C1 12.1 1.9 13 3 13H4.1",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneratedMessageCopyIcon);
export default __webpack_public_path__ + "static/media/generated-message-copy-icon.82c36f71b168d08b38f015dd7e56cf45.svg";
export { ForwardRef as ReactComponent };